// src/lib/direct-var-groups.js — noms des groupes d'infos du picker Direct
// (« + Info voyageur » de Voyageurs › Automatisations › Direct).
//
// SOURCE UNIQUE (pas un miroir), même montage que src/lib/sms-validator.js :
// CJS pur, zéro import, consommé
//   - côté CLIENT par DirectMessagesView (groupes affichés du picker) ;
//   - côté SERVEUR par lib/direct-vars-catalog.js (champ `group` du catalogue,
//     métadonnée d'affichage).
// CRA interdit l'import de la racine lib/ depuis src/, le require inverse
// lib/ → src/ est légal : le canonique vit donc ici.
//
// AFFICHAGE SEUL : ces noms ne sont ni stockés ni lus par le moteur d'envoi.

// Ancien nom « Réfs & politique » (abréviation) : renommé sans jargon (#1564).
const GROUPE_REFERENCES = "Références & annulation";

module.exports = { GROUPE_REFERENCES };
